import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JourneyCoreService } from './journey-core.service';
import { ApiModule } from '../api/api.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, ApiModule],
  providers: [JourneyCoreService],
})
export class JourneyCoreModule {}